<!--
 * @Description: 编辑标签页面
 * @Author: mdb
 * @Date: 2023-04-19 18:13:45
 * @LastEditTime: 2023-04-19 18:44:31
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm type="edit" title="编辑标签" subdomain="fbu" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from '@/views/marketing/marketingManage/tagsManage/components/DetailForm.vue'
</script>
<script lang="ts">
export default { name: 'DcCosFbuTagManageEdit' }
</script>

<style scoped></style>
